export default function arrayGroupBy(arr: any[], property: string) {
    return arr.reduce(function(memo, x) {
      if (!memo[property + "_" + x[property]]) { memo[property + "_" + x[property]] = []; }
      memo[property + "_" + x[property]].push(x);
      return memo;
    }, {});
  }